/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";

export type DeleteDependencyInput = {
    id?: string | null | undefined;
    csrfToken?: string | null | undefined;
    socketClientId?: string | null | undefined;
    clientMutationId?: string | null | undefined;
};
export type deleteDependencyMutationVariables = {
    input: DeleteDependencyInput;
};
export type deleteDependencyMutationResponse = {
    readonly deleteDependency: {
        readonly deletedDependencyId: string | null;
    } | null;
};
export type deleteDependencyMutation = {
    readonly response: deleteDependencyMutationResponse;
    readonly variables: deleteDependencyMutationVariables;
};



/*
mutation deleteDependencyMutation(
  $input: DeleteDependencyInput!
) {
  deleteDependency(input: $input) {
    deletedDependencyId
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input",
    "type": "DeleteDependencyInput!"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "DeleteDependencyPayload",
    "kind": "LinkedField",
    "name": "deleteDependency",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "deletedDependencyId",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "deleteDependencyMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "deleteDependencyMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": null,
    "metadata": {},
    "name": "deleteDependencyMutation",
    "operationKind": "mutation",
    "text": "mutation deleteDependencyMutation(\n  $input: DeleteDependencyInput!\n) {\n  deleteDependency(input: $input) {\n    deletedDependencyId\n  }\n}\n"
  }
};
})();
(node as any).hash = 'd12b0314d447acb4dc93c9e38eb13e77';
export default node;
